// extracted by mini-css-extract-plugin
module.exports = {"block-header":"styles_block-header__36ewE","header":"styles_header__2e3r0","back":"styles_back__W3IzN","tabs":"styles_tabs__1uzRI","resize":"styles_resize__2pSfU"};